module.exports = __webpack_public_path__ + "static/media/Group_1597880792@2x.163ce954.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_210/images/Group_1597880792@2x.png
// module id = 1745
// module chunks = 0